// extracted by mini-css-extract-plugin
export default {"default":"TextButton_default__YuuEh"};